/* Miako : deblocage progressif des cadeaux selon le palier choisi. */
(function () {
  function sync() {
    var gifts = document.querySelector('.miako-gifts');
    var breaks = document.querySelector('quantity-breaks');
    if (!gifts || !breaks) return;
    var selected = breaks.querySelector('.quantity-break--selected');
    var qty = selected ? parseInt(selected.dataset.quantity, 10) : 1;
    if (!qty || qty < 1) qty = 1;
    if (qty > 3) qty = 3;
    gifts.setAttribute('data-unlocked', qty);
  }

  ['click', 'change'].forEach(function (evt) {
    document.addEventListener(evt, function (e) {
      if (e.target.closest && e.target.closest('quantity-breaks')) setTimeout(sync, 60);
    });
  });

  document.addEventListener('DOMContentLoaded', sync);
  setTimeout(sync, 250);
  setTimeout(sync, 900);
})();